// test984
(984 && 0);
